export const PARTNER = 'ML_PARTNER_SESSION'

export const FEATURE_FLAG = 'FEATURE_FLAG'

export const ID_TOKEN = 'id_token'

export const SESSION_ID = 'session_id'

export const JWT_COOKIE = 'jwt_cookie'

export const CAFE_PREVIEW = 'cf'

export const DEFAULT_MAX_AGE = 60 * 60 * 24 * 365 // 1 year in seconds
